import React, { useEffect } from "react";
import { QueryClient, QueryClientProvider, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Truncate } from "@re-dev/react-truncate";
import Error from "./Error";
import Loader from "./Loader";
import BasicModal from "./BasicModal";
import parse from 'html-react-parser';

export const Services = () => {

const dataReturned=useQuery(
  {
    queryKey:["servicesData"],
    queryFn:()=>
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/service/?website=Company`)
    .then((res)=>res.data),
  }
)

if(dataReturned.isLoading){
  return(
    <Loader/>
  )
}

if(dataReturned.isError){
  return(
    <Error/>
  )
}

if(dataReturned.data){
  console.log(dataReturned.data);
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
           SERVICES THAT WE OFFER 
          </p>
        </div>
        <div className="row">
          {dataReturned.data
            ? dataReturned.data.map((d, i) => (
                <div key={`${d.id}-${i}`} className="col-md-4">
                  {" "}
                  <img style={{height:300}} src={process.env.REACT_APP_BACKEND_URL+d.image}/>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <Truncate
      lines={3}
      ellipsis={
        <span>
          ....<BasicModal title={d.name} description={parse(d.description)}/>
        </span>
      }
      onTruncate={(didTruncate) => {
        console.log(didTruncate)
      }}
    >
                    {parse(d.description)}
                    </Truncate>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
}
};

